module.exports = __webpack_public_path__ + "img/vegi-view.37438ff2.png";